







import { DialogTitle } from '../basic';
export default {
  name: 'Dialog',
  props: {
    title: String,
  },
  components: {
    DialogTitle,
  },
};
